const STYLES = {
  Richiesto: "bg-amber-100 text-amber-800 border-amber-300",
  IncaricoAccettato: "bg-emerald-100 text-emerald-800 border-emerald-300",
  Ricevuto: "bg-green-600 text-white border-green-700",
  Sottoscritto: "bg-sky-100 text-sky-800 border-sky-300",
  Rifiutato: "bg-red-100 text-red-800 border-red-300",
  Annullato: "bg-slate-200 text-slate-700 border-slate-400",
  Chiuso: "bg-emerald-100 text-emerald-900 border-emerald-400",
};

function derive(p) {
  if (p.stato_key) return { key: p.stato_key, label: p.stato_display || p.stato_key };
  if (p.stato === "Rifiutato") return { key: "Rifiutato", label: "Rifiutato" };
  if (p.stato === "Annullato") return { key: "Annullato", label: "Annullato" };
  if (p.stato === "Chiuso") return { key: "Chiuso", label: "Chiuso con ricevuta" };
  if (p.sottoscrizione) return { key: "Sottoscritto", label: "Preventivo sottoscritto" };
  if (p.stato === "Inviato" || p.stato === "Accettato") return { key: "Ricevuto", label: "Preventivo ricevuto" };
  if (p.stato === "Richiesto" && p.incarico_accettato_at) return { key: "IncaricoAccettato", label: "Incarico accettato" };
  return { key: "Richiesto", label: "Richiesto" };
}

export function PreventivoBadge({ p, stato, size }) {
  const d = p ? derive(p) : { key: stato, label: stato };
  const cls = STYLES[d.key] || "bg-slate-100 text-slate-700 border-slate-300";
  const sm = size === "sm";
  return (
    <span data-testid={`preventivo-stato-${d.key}`}
      className={`inline-flex items-center rounded-full font-bold ${sm ? "px-2 py-0.5 text-[11px] border" : "px-3 py-1 text-sm border-2"} ${cls}`}>
      {d.label}
    </span>
  );
}
